import React from 'react'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { EditOrderAction, useEditOrderSvc } from '../service'

import { useForm } from 'react-hook-form'

export function EditTip(props: { onClose: () => void; onSave: (action: EditOrderAction) => void}): JSX.Element {
  const editOrderSvc = useEditOrderSvc()

  const form = useForm({
    mode: 'onBlur',
    defaultValues: {
      value: editOrderSvc.getTip() / 100
    },
  })

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = form

  const validateAndSave = (data: any) => {
    props.onSave({op: 'update-tip', value: Math.round(data.value * 100), prev_value: editOrderSvc.getTip()})
    props.onClose()
  }

  return (
    <Modal isOpen={true} onClosed={props.onClose}>
      <ModalHeader>
        <span>Change Tip</span>
      </ModalHeader>
      <form className="form-horizontal" onSubmit={handleSubmit(validateAndSave)}>
        <ModalBody>
          <div className="form-group">
            <label htmlFor="value">Tip:</label>
            <input
              id="value"
              className="form-control input input-small"
              style={errors && errors.value ? { color: 'red' } : {}}
              type="number"
              step={0.01}
              {...register('value', {
                required: 'is required',
                min: { value: 0, message: 'must be greater or equal to 0' },
                valueAsNumber: true,
              })}
            />
            {errors && errors.value && <span className="text-danger">{errors.value.message}</span>}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button type="submit" color="primary">Save</Button>
          <Button color="secondary" onClick={props.onClose}>
            Cancel
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  )
}
